import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import { P_API_RESEARCH_LIB_CATEGORY, getConfig } from 'utils';

export async function removeResearchLibCategory(catId: string): Promise<void> {
  assertClientSide();

  const config = await getConfig();

  await axios.delete(
    `${P_API_RESEARCH_LIB_CATEGORY}/${catId}`,
    { headers: { 'csrf-token': config.CSRF } },
  );
}
